import clsx from 'clsx';
import { ReactNode } from 'react';

import { Screens } from 'src/interfaces/screens.types';
import AuthService from 'src/services/api/auth.service';

import { JoinCodeModal } from '../middle-school-view/single-session-code';
import { ElementarySchoolHeader } from './elementary-school-header';

import './elementary-school-view.scss';

export interface ElementarySchoolViewProps {
  children: ReactNode;
  currentScreen: Screens;
}

const ElementarySchoolView = ({
  children,
  currentScreen,
}: ElementarySchoolViewProps) => {
  const isTeacher = AuthService.isTeacher();

  return (
    <section
      className={clsx('elementary-school-view main-scrollbar amp-styles', {
        'elementary-school-view--teacher': isTeacher,
      })}
      data-testid="elementary-school-view"
    >
      <ElementarySchoolHeader currentScreen={currentScreen} />
      <div className="elementary-school-view__content">{children}</div>
      <JoinCodeModal />
    </section>
  );
};

export default ElementarySchoolView;
